var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailSendLine = function SvgMailSendLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 19.207a.9.9 0 0 1-.893.893H3.893A.893.893 0 0 1 3 19.207V18.3h16.2V7.77L12 14.25l-9-8.1V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9zM5.19 5.7 12 11.83l6.81-6.13zm-3.99 9h7.2v1.8H1.2zm0-4.5h4.5V12H1.2z"
  })));
};
export default SvgMailSendLine;